module.exports = __webpack_public_path__ + "static/media/1022691.d2bb5b97.jpg";